const Style = ({ isMobile, imageDesktop }) => `
  <style>
    .wrapper {
      ${
        isMobile
          ? `
          background: none;
          padding: 40px 16px 24px 16px;
          `
          : `
          background: url(${imageDesktop});
          background-position: right;
          background-repeat: no-repeat;
          padding: 40px 10% 24px 10%;
        `
      }
    }

    .main-content {
      ${
        isMobile
          ? `
          display: flex;
          flex-direction: row;
          justify-content: center;
        `
          : 'display: block;'
      }
    }

    .text-content {
      ${
        isMobile
          ? 'display: block;'
          : `
          display: flex;
          align-items: center;
        `
      }
    }

    .image-mobile {
      width: 85px;
      ${isMobile ? 'display: block;' : 'display: none;'}
    }

    .title-wrapper {
      ${isMobile ? 'width: unset;' : 'width: 33%;'}
    }

    .title {
      ${isMobile ? 'max-width: unset;' : 'max-width: 370px;'}
    }

    .data-claim-list {
      align-self: center;
      ${isMobile ? 'width: 100%;' : 'width: 33%;'}
    }

    .data-claim-list ul {
      margin-top: 24px;
    }

    .data-claim-list li {
      display: flex;
      gap: 24px;
      ${
        isMobile
          ? `
          margin-top: 10px;
        `
          : `
          margin-top: 20px;
          justify-content: center;
        `
      }
    }

    .data-claim-list li div {
      display: flex;
      align-items: center;
    }

    .data-claim-list li div:first-child {
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      -webkit-text-size-adjust: 100%;
      -ms-text-size-adjust: 100%;
      font-weight: 400;
      font-family: Spectral-ExtraLight, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
      line-height: 40px;
      letter-spacing: -.38px;
      flex-basis: 80px;
      text-align: center;
      justify-content: center;
      flex-shrink: 0;
      ${isMobile ? 'font-size: 38px;' : 'font-size: 40px;'}
    }

    .data-claim-list li div:nth-child(2) {
      font-family: GT-America-Standard-Regular;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.28px;
      ${
        isMobile
          ? 'font-size: 14px;'
          : `
          font-size: 16px;
          width: 280px;
        `
      }
    }

    .disclaimer {
      color: #717575;
      ${
        isMobile
          ? 'margin-top: 10px;'
          : `
          margin-top: 20px;
          text-align: center;
        `
      }
    }

    .badges {
      display: flex;
      flex-wrap: wrap;
      margin: 20px 0 24px 0;
      ${
        isMobile ? 'justify-content: space-around;' : 'justify-content: center;'
      }
    }

    .badges img {
      ${isMobile ? 'width: 33%;' : 'width: 150px;'}
    }

    .cta-1 {
      max-width: 280px;
      margin: 0 auto;
    }
  </style>`;

export default Style;
